import React from 'react';
import { useIntl } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import {
  TableFieldCellProps,
  TableFieldCells,
  TableFieldColumn,
} from '@eas/common-web';
import { Redirect } from '@components/redirect/redirect';
import { Defect } from '@models';
import { EvidenceBrowserUrl } from '@enums';
import { formatUserName } from './defect-detail-dialog';

export function CellImagesCount<T>({ value }: TableFieldCellProps<T>) {
  const count = (value as Defect['imagesAfter'])?.length ?? 0;
  if (count < 1) {
    return <Typography>-</Typography>;
  } else {
    return <Typography>Áno ({count})</Typography>;
  }
}

export function useColumns({
  hideRedirectInCurrent,
}: {
  hideRedirectInCurrent?: boolean;
}): TableFieldColumn<Defect>[] {
  const intl = useIntl();

  return [
    {
      name: intl.formatMessage({
        id: 'ZSD__DEFECTS__TABLE__COLUMN__WORK_ORDER',
        defaultMessage: 'Pracovný príkaz',
      }),
      datakey: 'workOrder.workOrderId',
      sortkey: 'workOrder.workOrderId',
      width: 150,
      CellComponent: function Cell(props: TableFieldCellProps<Defect>) {
        return (
          <>
            <Redirect
              url={EvidenceBrowserUrl.WORK_ORDERS}
              id={props.rowValue!.workOrder?.id ?? ''}
              showRedirectInCurrent={!hideRedirectInCurrent}
            />
            {props.rowValue!.workOrder?.workOrderId}
          </>
        );
      },
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__DEFECTS__TABLE__COLUMN__TYPE_CATEGORY_NAME',
        defaultMessage: 'Kontrolný bod',
      }),
      datakey: 'type.category',
      width: 200,
      CellComponent: ({ value }) => {
        return <Typography>{value?.name ?? ''}</Typography>;
      },
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__DEFECTS__TABLE__COLUMN__TYPE_NAME',
        defaultMessage: 'Nedostatok',
      }),
      datakey: 'type.name',
      sortkey: 'type.name',
      width: 200,
      CellComponent: TableFieldCells.TextCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__DEFECTS__TABLE__COLUMN__SEVERITY',
        defaultMessage: 'Závažnosť',
      }),
      datakey: 'type.severity',
      sortkey: 'type.severity',
      width: 100,
      CellComponent: TableFieldCells.NumberCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__DEFECTS__TABLE__COLUMN__DISCOVERY_DATE',
        defaultMessage: 'Dátum zadania',
      }),
      datakey: 'discoveryDate',
      sortkey: 'discoveryDate',
      width: 150,
      CellComponent: TableFieldCells.DateTimeCell,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__DEFECTS__TABLE__COLUMN__DISCOVERED_BY',
        defaultMessage: 'Kto zadal',
      }),
      datakey: 'discoveredBy',
      width: 150,
      CellComponent: ({ value }) => (
        <Typography>{formatUserName(value)}</Typography>
      ),
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__DEFECTS__TABLE__COLUMN__SOLVED',
        defaultMessage: 'Stav',
      }),
      datakey: 'solved',
      sortkey: 'solved',
      width: 120,
      CellComponent: ({ value }) => (
        <Typography>{value ? 'Vyriešený' : 'Nevyriešený'}</Typography>
      ),
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__DEFECTS__TABLE__COLUMN__IMAGES_AFTER',
        defaultMessage: 'Fotografie pred',
      }),
      datakey: 'imagesBefore',
      sortkey: 'imagesBefore',
      width: 150,
      CellComponent: CellImagesCount,
    },
    {
      name: intl.formatMessage({
        id: 'ZSD__DEFECTS__TABLE__COLUMN__IMAGES_AFTER',
        defaultMessage: 'Fotografie po',
      }),
      datakey: 'imagesAfter',
      sortkey: 'imagesAfter',
      width: 150,
      CellComponent: CellImagesCount,
    },
  ];
}
